var _temp;

import events from '../../events.yaml';
import Raven from 'Raven';
import { createTracker } from 'usage-tracker';
import { createTracker as createTrackerPublic } from 'usage-tracker-public';
import { EventType } from '../types';
const NAMESPACE = 'connect-dot-com-ui';

// T extends {} is a hack to get around formatting issues with arrow functions and generics
const waitForGlobal = (win = window, key, timeout = 100) => {
  const wait = resolve => {
    if (win[key]) {
      resolve(win[key]);
    } else {
      setTimeout(wait.bind(this, resolve), timeout);
    }
  };

  return new Promise(wait);
};

const isPublicUser = user => {
  return !user || !user.length;
};

export const gtag = (...args) => {
  const g = window.gtag;
  if (!g) return;
  g(...args);
};

const consentToGa = () => {
  gtag('consent', 'default', {
    analytics_storage: 'default'
  });
};

export const UsageTracker = new (_temp = class UsageTracker {
  constructor() {
    this.hasConsented = false;
    this.queue = [];
  }

  waitForCookieConsent(win) {
    return waitForGlobal(win, '_hsp').then(hsp => {
      hsp.push(['addPrivacyConsentListener', consent => {
        if (consent.allowed) {
          this.hasConsented = true;
          consentToGa();
          this.drainQueue();
        }
      }]);
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error("Couldn't find Hubspot cookie message queue", error);
    });
  }

  init({
    userEmail,
    win = window
  }) {
    return this.waitForCookieConsent(win).then(() => {
      if (this.userEmail === userEmail) return Promise.resolve();
      const config = {
        events,
        allowUnauthed: true,
        properties: {
          namespace: NAMESPACE,
          hubId: null,
          email: null
        },
        onError: err => {
          Raven.captureMessage('usage-tracker-js event error', {
            extra: {
              message: err.message
            }
          }); // eslint-disable-next-line no-console

          console.error(err);
        }
      };

      if (!isPublicUser(userEmail)) {
        this.userEmail = userEmail;

        if (config.properties) {
          config.properties.email = userEmail;
        }

        this.tracker = createTracker(config);
      } else {
        this.tracker = createTrackerPublic(config);
      }

      return Promise.resolve();
    });
  }

  queueEvent(event) {
    this.queue.push(event);
  }

  drainQueue() {
    while (this.queue.length > 0) {
      const event = this.queue.shift();

      if (event && this.tracker) {
        const {
          type,
          props
        } = event;
        this.track(type, props);
      }
    }
  }

  shouldQueue() {
    return !this.hasConsented;
  }

  track(event, props) {
    if (this.tracker && !this.shouldQueue()) {
      this.tracker.track(event, props);

      if (event === EventType.PageView && props) {
        const {
          pathname,
          search = ''
        } = props;

        if (pathname) {
          gtag('set', 'page_path', pathname + search);
          gtag('event', 'page_view');
        }
      }
    } else {
      this.queueEvent({
        type: event,
        props
      });
    }
  }

  trackPageView(screen, props) {
    this.track(EventType.PageView, Object.assign({
      screen
    }, props));
  }

  trackInteraction(props) {
    this.track(EventType.Interaction, Object.assign({}, props));
  }

}, _temp)();